import {
  fetchGet,
  fetchPost,
  post
} from './axios'

const basrUrl = '/api/'

const requestConfig = {
  gtBanners: 'banners',
  recommendQuiz: 'recommendQuiz',
  cateList: 'cateList',
  quizList: 'quizList',
  getPhoneVerifyCode: 'getPhoneVerifyCode',
  quiz: 'quiz',
  details: 'details',
  commentList: 'commentList',
  register: 'register',
  order: 'h5/order',
  giftOrder: 'giftOrder',
  submit: 'quiz/submit',
  fav: 'seen/fav',
  signIn: 'signIn',
  signInWithCode: 'signInWithCode',
  unfinished: 'order/unfinished',
  reportList: 'orderList/submit',
  withOrder: 'quiz/record/withOrder',
  seen: 'seen',
  getQuizListByIds: 'quizList/all/ids',
  coupons: 'coupons',
  comment: 'comment',
  checkPay: 'order/checkPay',
  wecharOpenId: 'xinka/h5/openId',
  openId: 'user/openId',
  userInfo: 'user/info',
  wapOpenId: 'user/wap/openId',
  getShareToken: 'wx/applet/getShareToken',
  catchCode: 'getPhoneVerifyCode',
  phoneNumberLogin: 'phoneNumberLogin'
}

export function requestApiByGet(urlName, params) {
  if (params) {
    return fetchGet(`${basrUrl}${requestConfig[urlName]}/${params}`)
      .then(res => {
        return res
      })
      .catch(error => {
        return error
      })
  } else {
    return fetchGet(`${basrUrl}${requestConfig[urlName]}`)
      .then(res => {
        return res
      })
      .catch(error => {
        return error
      })
  }
}
export function requestApiGet(urlName, params) {
  if (params) {
    return fetchGet(`${basrUrl}${requestConfig[urlName]}`, params)
      .then(res => {
        return res
      })
      .catch(error => {
        return error
      })
  } else {
    return fetchGet(`${basrUrl}${requestConfig[urlName]}`)
      .then(res => {
        return res
      })
      .catch(error => {
        return error
      })
  }
}

// application/json 格式
export function requestApiByPost(urlName, params) {
  return fetchPost(`${basrUrl}${requestConfig[urlName]}`, params)
    .then(res => {
      return res
    })
    .catch(error => {
      return error
    })
}

// application/x-www-form-urlencoded 格式
export function requestApiPost(urlName, params) {
  return post(`${basrUrl}${requestConfig[urlName]}`, params)
    .then(res => {
      return res
    })
    .catch(error => {
      return error
    })
}
